"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Definable_1 = __importDefault(require("./Definable"));
class Tileset extends Definable_1.default {
    constructor(slug, data) {
        super(slug);
        this._data = data;
    }
    get columns() {
        return this._data.columns;
    }
    get tiles() {
        if (this._data.tiles) {
            return this._data.tiles;
        }
        return [];
    }
    get tileWidth() {
        return this._data.tilewidth;
    }
    get tileHeight() {
        return this._data.tileheight;
    }
}
exports.default = Tileset;
